<template>
  <div>
    <el-alert
      title="流程：新建草稿，生成账面，录入实盘，再过账。过账按差异增减库存，并写入库存流水。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.stocktakingCode" clearable placeholder="盘点单号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.wareHouseId" clearable filterable placeholder="仓库" style="width:160px">
        <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
      </el-select>
      <el-select v-model="query.stocktakingState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="盘点中" value="01" />
        <el-option label="已过账" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="stocktakingCode" label="盘点单号" width="180" />
      <el-table-column prop="wareHouseName" label="仓库" min-width="140" show-overflow-tooltip />
      <el-table-column prop="stocktakingDate" label="盘点日期" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.stocktakingState === '02' ? 'success' : (row.stocktakingState === '01' ? 'warning' : 'info')">
            {{ stateName(row.stocktakingState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createByName" label="制单人" width="100" />
      <el-table-column label="操作" width="210" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row.stocktakingId)">明细</el-button>
          <el-button type="text" :disabled="row.stocktakingState !== '00' && row.stocktakingState !== '01'" @click="doGenerate(row)">生成账面</el-button>
          <el-button type="text" :disabled="row.stocktakingState !== '01'" @click="doPost(row)">过账</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.stocktakingState !== '00'" @click="doDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog title="新建盘点" :visible.sync="createVisible" width="480px" :close-on-click-modal="false">
      <el-form :model="createForm" label-width="90px">
        <el-form-item label="仓库">
          <el-select v-model="createForm.wareHouseId" filterable style="width:100%">
            <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
          </el-select>
        </el-form-item>
        <el-form-item label="盘点日期">
          <el-date-picker v-model="createForm.stocktakingDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="createForm.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitCreate">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="盘点明细" :visible.sync="detailVisible" width="980px" :close-on-click-modal="false">
      <div v-if="detail" style="margin-bottom:8px">
        <span>{{ detail.stocktakingCode }} / {{ detail.wareHouseName }}</span>
        <el-tag size="mini" style="margin-left:8px">{{ stateName(detail.stocktakingState) }}</el-tag>
      </div>
      <el-table v-if="detail" :data="detail.lineList || []" border size="small" max-height="420">
        <el-table-column prop="productNumber" label="产品编码" width="120" />
        <el-table-column prop="productName" label="产品名称" min-width="140" />
        <el-table-column prop="batchNo" label="批次" width="120" />
        <el-table-column prop="wareAreaName" label="库位" width="100" />
        <el-table-column prop="bookQty" label="账面" width="100" align="right" />
        <el-table-column label="实盘" width="140">
          <template slot-scope="{ row }">
            <el-input-number v-if="detail.stocktakingState === '01'" v-model="row.realQty" :min="0" :precision="6" size="mini" style="width:100%" @change="recalc(row)" />
            <span v-else>{{ row.realQty }}</span>
          </template>
        </el-table-column>
        <el-table-column label="差异" width="100" align="right">
          <template slot-scope="{ row }">
            <span :style="{ color: Number(row.differenceQty) !== 0 ? '#F56C6C' : '' }">{{ row.differenceQty }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button v-if="detail && detail.stocktakingState === '01'" type="primary" :loading="saving" @click="saveCounts">保存实盘</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listStocktaking, getStocktaking, saveStocktaking, deleteStocktaking,
  generateStocktaking, saveStocktakingCounts, postStocktaking
} from '../../api/stocktaking'
import { selectEnabledWareHouse } from '../../api/warehouse'

function emptyCreate() {
  return { wareHouseId: '', stocktakingDate: null, remark: '' }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { stocktakingCode: '', wareHouseId: '', stocktakingState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, warehouses: [],
      createVisible: false, createForm: emptyCreate(),
      detailVisible: false, detail: null
    }
  },
  created() {
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    stateName(state) {
      if (state === '00') return '草稿'
      if (state === '01') return '盘点中'
      if (state === '02') return '已过账'
      return state || ''
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listStocktaking({
        currentPage: this.page, pageSize: this.pageSize,
        stocktakingCode: this.query.stocktakingCode, wareHouseId: this.query.wareHouseId,
        stocktakingState: this.query.stocktakingState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openCreate() {
      this.createForm = emptyCreate()
      this.createVisible = true
    },
    submitCreate() {
      if (!this.createForm.wareHouseId) { this.$message.warning('请选择仓库'); return }
      this.saving = true
      saveStocktaking(this.createForm).then(res => {
        this.$message.success('已创建')
        this.createVisible = false
        this.load()
        if (res.data && res.data.stocktakingId) this.openDetail(res.data.stocktakingId)
      }).finally(() => { this.saving = false })
    },
    openDetail(id) {
      getStocktaking(id).then(res => {
        this.detail = res.data || { lineList: [] }
        ;(this.detail.lineList || []).forEach(line => this.recalc(line))
        this.detailVisible = true
      })
    },
    recalc(row) {
      const book = Number(row.bookQty) || 0
      const real = row.realQty == null ? book : Number(row.realQty)
      row.differenceQty = (real - book).toFixed(6)
    },
    doGenerate(row) {
      this.$confirm('按仓库账面生成或覆盖盘点明细？', '提示', { type: 'warning' }).then(() => {
        generateStocktaking(row.stocktakingId).then(() => {
          this.$message.success('已生成')
          this.load()
          this.openDetail(row.stocktakingId)
        })
      }).catch(() => {})
    },
    saveCounts() {
      this.saving = true
      saveStocktakingCounts(this.detail.stocktakingId, this.detail.lineList || []).then(() => {
        this.$message.success('已保存')
        this.openDetail(this.detail.stocktakingId)
      }).finally(() => { this.saving = false })
    },
    doPost(row) {
      this.$confirm('过账将按差异调整库存，继续？', '提示', { type: 'warning' }).then(() => {
        postStocktaking(row.stocktakingId).then(() => {
          this.$message.success('过账成功')
          this.load()
          if (this.detail && this.detail.stocktakingId === row.stocktakingId) this.openDetail(row.stocktakingId)
        })
      }).catch(() => {})
    },
    doDelete(row) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteStocktaking([row.stocktakingId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
